import React, { useState, useEffect } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import CircularProgress from '@mui/material/CircularProgress';

const FormFichaTecnica = ({ data, Save, CloseModal }) => {
    const { t } = useTranslation("common");
    const [articulo, setArticulo] = useState(data);
    const [atributos, setAtributos] = useState(null);
    const [camposInvalidos, setCamposInvalidos] = useState([]);
    let [atributosArticulo, setAtributosArticulo] = useState(articulo.atributos || []);

    const downloadDataCategoria = async (query, index) => await fetchConToken(`Categorias/DescargarAtributo?claveCategoria=${query}&sucursal_id=${articulo.sucursal_Id}`)
        .then((_res) => { if (index === 1) loadDataAtributos(query, 2); }).catch((_error) => { Swal.fire('Error', `No se pudieron descargar los Atributos de la categoria ${query}`, 'error'); });

    const loadDataAtributos = async (query, index) => await fetchConToken(`Categorias/AtributosXCategoria?pagina=${1}&totalXpagina=${100}&claveCategoria=${query}`).then((resp) => {
        if (resp && resp.length > 0) resp.filter((x) => x.clave_Atributo === 'ITEM_CONDITION').forEach((x) => { if (x.clave_Atributo === 'ITEM_CONDITION') x.required = true; });

        setAtributos(resp);
        if (resp.length === 0 && index === 1) downloadDataCategoria(query, index);
        else if (resp.length === 0 && index === 2) Swal.fire('Error', `No se encontraron Atributos de la categoria ${query}`, 'error');
    });

    function handleChangeAtributo(claveAtributo, valor) {
        if (camposInvalidos.includes(claveAtributo)) {
            setCamposInvalidos(camposInvalidos.filter((x) => x !== claveAtributo));
        }

        if (claveAtributo === 'WARRANTY_TYPE') {
            setArticulo({ ...articulo, garantia: valor });
            return;
        }

        var res = atributosArticulo?.find((x) => x.clave_Atributo === claveAtributo);
        if (res === null || res === undefined) {
            if (atributosArticulo === null || atributosArticulo === undefined) setAtributosArticulo([]);

            res = atributos.find((x) => x.clave_Atributo === claveAtributo);
            res.id = 0;
            res.valor = valor;
            atributosArticulo.push(res);
        }
        else res.valor = valor;

        setArticulo({
            ...articulo,
            atributos: atributosArticulo
        });
    }

    const validarCamposRequeridos = () => {
        if (!atributos) return [];
        const faltantes = [];

        atributos.forEach((atrb) => {
            if (!atrb.required) return;

            // WARRANTY_TYPE se guarda en articulo.garantia, no en articulo.atributos
            if (atrb.clave_Atributo === 'WARRANTY_TYPE') {
                if (!articulo.garantia || articulo.garantia.trim() === '') faltantes.push(atrb);

                return;
            }

            const valorGuardado = atributosArticulo?.find((x) => x.clave_Atributo === atrb.clave_Atributo)?.valor;
            if (!valorGuardado || valorGuardado.toString().trim() === '') faltantes.push(atrb);
        });

        return faltantes;
    };

    const SaveData = () => {
        const faltantes = validarCamposRequeridos();
        if (faltantes.length > 0) {
            setCamposInvalidos(faltantes.map((x) => x.clave_Atributo));
            Swal.fire('Campos requeridos', `Debes completar los siguientes campos: <br/><b>${faltantes.map((x) => x.nombre).join(', ')}</b>`, 'warning');
            return;
        }

        setCamposInvalidos([]);
        Save(articulo);
    };

    useEffect(() => { loadDataAtributos(articulo.clave_Categoria, 1) }, [articulo.clave_Categoria]);

    return (<div style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
        <div style={{ overflowY: 'auto', flex: '1 1 auto', minHeight: '70vh' }}>
            <div className='espacio15px' />
            <FichaTecnica data={articulo} Atributos={atributos} HandleChangePrincipal={handleChangeAtributo} CamposInvalidos={camposInvalidos} />
        </div>
        <div className='espacio15px' />
        <div className='row' style={{ flex: '0 0 auto' }}>
            <div className='col-sm-8' />
            <div className='col-sm-2'>
                <button className='btn btn-outline-danger' onClick={CloseModal}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-x-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z' />
                    </svg>
                    &nbsp; &nbsp; {t('app.botones.cancelar')}
                </button>
            </div>
            <div className='col-sm-2'>
                <button className='btn btn-outline-success' onClick={SaveData}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp; {t('app.botones.guardar')}
                </button>
            </div>
        </div>
    </div>);
}

const FichaTecnica = ({ data, Atributos, HandleChangePrincipal, CamposInvalidos }) => {
    const GetAtributos = () => {
        var atributosReturn = [];
        if (Atributos) {
            Atributos = Atributos.filter((item) => !item.readonly && item.clave_Atributo !== 'PRODUCT_DATA_SOURCE' && item.clave_Atributo !== 'SELLER_SKU');
            var AtributosAux = Atributos.filter((item) => item.value_Type !== 'boolean');
            AtributosAux = AtributosAux.filter((item) => item.clave_Atributo !== 'WARRANTY_TYPE');
            AtributosAux = AtributosAux.filter((item) => item.clave_Atributo !== 'WARRANTY_TIME');
            for (let i = 0; i < AtributosAux.length; i += 3) atributosReturn.push([AtributosAux[i], AtributosAux[i + 1], AtributosAux[i + 2]]);
        }

        return atributosReturn;
    }

    const GetAtributosGarantia = () => {
        var atributosReturn = [];
        if (Atributos) {
            Atributos = Atributos.filter((item) => !item.readonly && item.clave_Atributo !== 'PRODUCT_DATA_SOURCE' && item.clave_Atributo !== 'SELLER_SKU');
            atributosReturn = Atributos.filter((item) => item.clave_Atributo === 'WARRANTY_TIME' || item.clave_Atributo === 'WARRANTY_TYPE');
        }

        return atributosReturn;
    }

    const GetAtributosBool = () => {
        var atributosReturn = [];
        if (Atributos) {
            Atributos = Atributos.filter((item) => !item.readonly && item.clave_Atributo !== 'PRODUCT_DATA_SOURCE' && item.clave_Atributo !== 'SELLER_SKU');
            var AtributosBool = Atributos.filter((item) => item.value_Type === 'boolean');
            for (let i = 0; i < AtributosBool.length; i += 3) atributosReturn.push([AtributosBool[i], AtributosBool[i + 1], AtributosBool[i + 2]]);
        }

        return atributosReturn;
    }

    const RowFichaTecnica = (Atributos, key) => {
        return (<div key={key} className='row'>
            {Atributos && [...Atributos].sort((a, b) => (b.required ? 1 : 0) - (a.required ? 1 : 0)).map((item) => {
                return item && (<CampoFichaTecnica
                    key={item.clave_Atributo}
                    data={data}
                    Atributo={item}
                    HandleChangePrincipal={HandleChangePrincipal}
                    IsInvalid={CamposInvalidos?.includes(item.clave_Atributo)}
                />);
            })}
        </div>);
    }

    const RowGarantiaFichaTecnica = (Atributos) => {
        if (Atributos && Atributos.length > 0) return (<div key='ATRB_WARRANTY' className='row'>
            {Atributos && (<CampoGarantiaFichaTecnica data={data} Atributos={Atributos} HandleChangePrincipal={HandleChangePrincipal} />)}
        </div>);
    }

    return (<>
        <div className='espacio15px' />
        <div className='container-fluid'>
            {(!Atributos || Atributos.length === 0) && <div style={{ height: '10vw' }}>
                <div style={{ height: '4vw' }} />
                <div className='col-md-12 row' style={{ width: '100%' }}>
                    <div className='col-sm-5' />
                    <div className='col-sm-1' style={{ display: 'grid' }}><div className='card-body text-start'><CircularProgress /></div></div>
                    <div className='col-sm-5' />
                </div>
            </div>}
            {Atributos && GetAtributos().map((item) => { return RowFichaTecnica(item, `ATRB_${item[0].clave_Atributo}`); })}
            {Atributos && RowGarantiaFichaTecnica(GetAtributosGarantia())}
            {Atributos && GetAtributosBool().map((item) => { return RowFichaTecnica(item, `ATRB_BOOL_${item[0].clave_Atributo}`); })}
        </div>
    </>);
}

const CampoFichaTecnica = ({ data, Atributo, HandleChangePrincipal, IsInvalid }) => {
    const [initialObjectUnidad, setInitialObjectUnidad] = useState('');
    const claseInput = (base) => IsInvalid ? `${base} is-invalid` : base; 
    const valueInitial = () => {
        switch (Atributo.value_Type) {
            case 'boolean': return data.atributos?.find(x => x.clave_Atributo === Atributo.clave_Atributo)?.valor ?? '' === "Si";
            case 'number_unit': return 0;
            default: return data.atributos?.find(x => x.clave_Atributo === Atributo.clave_Atributo)?.valor ?? '';
        }
    };
    const [initialObject, setInitialObject] = useState(valueInitial());

    const getCampo = () => {
        if (Atributo.value_Type === 'boolean') return (<>
            <div className='espacio15px' />
            <div className='form-check form-switch margin_left_switch'>
                <input
                    type='checkbox'
                    role='switch'
                    className='form-check-input'
                    name={Atributo.clave_Atributo}
                    checked={initialObject}
                    onChange={handleInputChange}
                />
                <label htmlFor={Atributo.clave_Atributo} className='margin_left_switch margin_top_switch_label'>{Atributo.nombre}</label> &nbsp;&nbsp;
            </div>
        </>);

        if (Atributo.tiene_Values && Atributo.values) return (Atributo.value_Type === 'number_unit') ? (<>
            <label htmlFor={Atributo.clave_Atributo} className='form-label'>{Atributo.nombre}{Atributo.required ? '*' : ''}</label>
            <div className='row'>
                <div className='col-sm-6' style={{ display: 'grid' }}>
                    <input
                        type='number'
                        className={claseInput('form-control')}
                        maxLength={100}
                        min={0}
                        name={Atributo.clave_Atributo}
                        required={Atributo.required}
                        value={initialObject}
                        onChange={handleInputChange}
                    />
                </div>
                <div className='col-sm-6' style={{ display: 'grid' }}>
                    <select className={claseInput('form-select')} name='SELECT_UNIDAD' required={Atributo.required} value={initialObjectUnidad} onChange={handleInputChange}>
                        <option key='DEFAULT' value=''>Seleccione</option>
                        {Atributo.values.map((item) => { return (<option key={item.nombre} value={item.nombre}>{item.nombre}</option>); })}
                    </select>
                </div>
            </div>
        </>) : (<>
            <label htmlFor={Atributo.clave_Atributo} className='form-label' style={IsInvalid ? { color: '#dc3545' } : {}}>{Atributo.nombre}{Atributo.required ? '*' : ''}</label>
            <div className={IsInvalid ? "form-control select-editable is-invalid" : "form-control select-editable"}>
                <select className='form-select' name={Atributo.clave_Atributo} onChange={handleInputChange}>
                    <option key='DEFAULT' value=''>Seleccione</option>
                    {Atributo.values.map((item) => { return (<option key={item.nombre} value={item.nombre}>{item.nombre}</option>); })}
                </select>
                <input type="text" className='form-control' name={Atributo.clave_Atributo} required={Atributo.required} value={initialObject} onChange={handleInputChange} />
            </div>
        </>);

        return (<>
            <label htmlFor={Atributo.clave_Atributo} className='form-label'>{Atributo.nombre}{Atributo.required ? '*' : ''}</label>
            <input
                type={Atributo.value_Type === 'number_unit' ? 'number' : 'text'}
                className={claseInput('form-control')}
                maxLength={100}
                name={Atributo.clave_Atributo}
                required={Atributo.required}
                value={initialObject}
                onChange={handleInputChange}
            />
        </>);
    }

    function handleInputChange(event) {
        //console.log(event);
        const target = event.target;
        if (target.type === "checkbox") {
            setInitialObject(target.checked);
            HandleChangePrincipal(Atributo.clave_Atributo, target.checked ? 'Si' : 'No');
            return;
        }

        if (target.name === 'SELECT_UNIDAD') {
            setInitialObjectUnidad(target.value);
            HandleChangePrincipal(Atributo.clave_Atributo, `${initialObject} ${target.value}`);
            return;
        }

        if (target.type === "number") {
            setInitialObject(target.value);
            var valor = (initialObjectUnidad && initialObjectUnidad !== '') ? `${target.value} ${initialObjectUnidad}` : target.value;
            HandleChangePrincipal(Atributo.clave_Atributo, valor);
            return;
        }

        setInitialObject(target.value);
        HandleChangePrincipal(Atributo.clave_Atributo, target.value);
    }

    useEffect(() => {
        if (Atributo.value_Type === 'number_unit') {
            var valor = data.atributos?.find(x => x.clave_Atributo === Atributo.clave_Atributo)?.valor ?? '';
            if (Atributo.tiene_Values) {
                var cantidad = valor.split(' ');
                var val = '';
                var unidad = '';
                if (cantidad.length > 1) {//si el valor viene 1 km se pinta en pantalla solo el 1
                    val = cantidad[0];
                    unidad = cantidad[1];
                }
                else {
                    //si el valor viene 1V se presenta en pantalla solo el 1
                    if (valor !== "" && valor.substring(valor.length - 1, 1).toUpperCase() === "V") {
                        val = valor.substring(0, valor.length - 1);
                        unidad = valor.substring(valor.length - 1, 1);
                    }
                    else unidad = cantidad[0];
                }
                setInitialObjectUnidad(unidad);
                valor = val;
            }
            setInitialObject(valor);
        }
    }, []);

    return (<div className='col-md-4' style={{ display: 'grid' }}><div className='card-body text-start'>{getCampo()}</div></div>);
}

const CampoGarantiaFichaTecnica = ({ data, Atributos, HandleChangePrincipal }) => {
    const getAtributo = (clave) => { return Atributos.find((item) => item.clave_Atributo === clave); }
    const [atributoTipoGarantia,] = useState(getAtributo('WARRANTY_TYPE'));
    const [atributoTiempoGarantia,] = useState(getAtributo('WARRANTY_TIME'));
    const [tipoGarantia, setTipoGarantia] = useState('');
    const [tiempoGarantia, setTiempoGarantia] = useState('0');
    const [unidadTiempoGarantia, setUnidadTiempoGarantia] = useState('');
    const [garantia, setGarantia] = useState(true);
    const isSoloSingarantia = () => { if (atributoTipoGarantia && atributoTipoGarantia.values) return atributoTipoGarantia.values.filter((item) => item.valor !== 'Sin garantía').length > 0; }
    function handleInputChange(event) {
        const target = event.target;
        if (target.name === 'WARRANTY_TYPE') {
            setGarantia(target.value !== 'Sin garantía');
            setTipoGarantia(target.value);
            HandleChangePrincipal('WARRANTY_TYPE', target.value === 'Sin garantía' ? target.value : `${target.value}: ${tiempoGarantia} ${unidadTiempoGarantia}`);
        }
        else if (target.name === 'W_TIME') {
            setTiempoGarantia(target.value);
            HandleChangePrincipal('WARRANTY_TYPE', target.value === 'Sin garantía' ? target.value : `${tipoGarantia}: ${target.value} ${unidadTiempoGarantia}`);
        }
        else {
            setUnidadTiempoGarantia(target.value);
            HandleChangePrincipal('WARRANTY_TYPE', target.value === 'Sin garantía' ? target.value : `${tipoGarantia}: ${tiempoGarantia} ${target.value}`);
        }

    }

    useEffect(() => {
        var valor = data.garantia ?? '';
        setGarantia(valor !== 'Sin garantía');
        if (valor !== 'Sin garantía') {
            var nombreGarantia = valor.split(':');
            if (nombreGarantia.length > 1) { //contempla la situacion en la que la garantia se encuentre de la siguiente manera: Garantía de fábrica: 1 años
                setTipoGarantia(nombreGarantia[0]);
                var tiempoGarantia = nombreGarantia[1].trim().split(' ');
                if (tiempoGarantia.length > 1) setUnidadTiempoGarantia(tiempoGarantia[1]);

                setTiempoGarantia(tiempoGarantia[0]);
                return;
            }
        }

        setTipoGarantia(valor);
    }, []);

    return (<>{atributoTipoGarantia && (
        <div className='col-md-4' style={{ display: 'grid' }}>
            <div className='card-body text-start'>
                <label htmlFor={atributoTipoGarantia.clave_Atributo} className='form-label'>{atributoTipoGarantia.nombre}</label>
                <select className='form-select' name={atributoTipoGarantia.clave_Atributo} required={atributoTipoGarantia.required} value={tipoGarantia} onChange={handleInputChange}>
                    {atributoTipoGarantia.values.map((item) => { return (<option key={item.nombre} value={item.nombre}>{item.valor}</option>); })}
                </select>
            </div>
        </div>
    )}
        {isSoloSingarantia() && atributoTiempoGarantia && (
            <div className='col-md-4' style={{ display: 'grid' }}>
                <div className='card-body text-start'>
                    <label htmlFor={atributoTiempoGarantia.clave_Atributo} className='form-label'>{atributoTiempoGarantia.nombre}</label>
                    <div className='row'>
                        <div className='col-sm-6' style={{ display: 'grid' }}>
                            <input
                                type='number'
                                className={garantia ? 'form-control' : 'form-control form-control-disabled'}
                                min={0}
                                maxLength={100}
                                name='W_TIME'
                                value={tiempoGarantia}
                                onChange={handleInputChange}
                                disabled={!garantia}
                            />
                        </div>
                        <div className='col-sm-6' style={{ display: 'grid' }}>
                            <select
                                className={garantia ? 'form-select' : 'form-select form-control-disabled'}
                                name={atributoTiempoGarantia.clave_Atributo}
                                required={atributoTiempoGarantia.required}
                                value={unidadTiempoGarantia}
                                onChange={handleInputChange}
                                disabled={!garantia}>
                                {atributoTiempoGarantia.values.map((item) => { return (<option key={item.nombre} value={item.nombre}>{item.nombre}</option>); })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        )}</>);
}

export { FormFichaTecnica, FichaTecnica };